<script lang="ts">import { Button } from "@infinitro/button";
import { t, Verbiage } from "@infinitro/content";
import { ModalDialog, pushModal } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import VipEarnCard from "./vip-earn-card.svelte";
import VipSectionTitle from "./vip-section-title.svelte";
const cards = [
	{
		titleKey: "vip_momentum_instant_cashback_title",
		descriptionKey: "vip_momentum_instant_cashback_description",
		icon: "instant-cashback"
	},
	{
		titleKey: "vip_momentum_weekly_reward_title",
		descriptionKey: "vip_momentum_weekly_reward_description",
		icon: "weekly-reward"
	},
	{
		titleKey: "vip_momentum_monthly_reward_title",
		descriptionKey: "vip_momentum_monthly_reward_description",
		icon: "monthly-reward"
	},
	{
		titleKey: "vip_momentum_rank_up_reward_title",
		descriptionKey: "vip_momentum_rank_up_reward_description",
		icon: "rank-up-reward"
	}
];
const handleSignup = () => {
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
</script>

<section class="earn-every-day">
	<VipSectionTitle title={$t(Verbiage['vip_momentum_every_day_title'])} />
	<InfoCard width="100%" borderRadius="20px">
		<div class="earn-every-day-inner">
			<div class="earn-grid">
				{#each cards as card, i (card.titleKey)}
					<VipEarnCard
						title={$t(Verbiage[card.titleKey])}
						description={$t(Verbiage[card.descriptionKey])}
						icon={card.icon}
						isLast={i === cards.length - 1}
					/>
				{/each}
			</div>
			<div class="cta">
				<Button
					text={$t(Verbiage['vip_momentum_register_cta'])}
					variant="primary"
					minWidth
					onClick={handleSignup}
				/>
			</div>
		</div>
	</InfoCard>
</section>

<style>
	.earn-every-day {
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 1rem
}
	.earn-every-day-inner {
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 1rem
}
	.earn-grid {
		display: grid;
		grid-template-columns: repeat(1, minmax(0, 1fr));
		gap: 0px
}
	@media (min-width: 1024px) {
		.earn-grid {
				grid-template-columns: repeat(2, minmax(0, 1fr));
				-moz-column-gap: 2rem;
				     column-gap: 2rem;
				row-gap: 1.5rem
		}
	}
	.cta {
		margin-top: 0.5rem;
		display: flex;
		justify-content: center
}
</style>
